import axios from "axios";
import { Region } from "../utils/httpclient";

export const getGeoInfo = async (): Promise<Region | null> => {
  try {
    const response = await axios.get("https://ipapi.co/json/");
    let data = response.data;
    let countryName = data.country_name;
    let countryCode = data.country_code;
    let languageCode = data.languages.split("-")[0].toUpperCase();
    // let languages = data.languages;
    // let language = languages ? languages.split(",")[0] : "en";
    return { countryName: countryName, countryCode: countryCode, languageCode: languageCode };
  } catch (error) {
    // Return default values if there is an error
    return { countryName: "United States", countryCode: "US", languageCode: "EN" };
  }
};
